import { AuthHttpInterceptor } from "#interceptors/auth.interceptor";
import { CacheErrorInterceptor } from "#interceptors/cache.interceptor";

export const interceptors: any[] = [AuthHttpInterceptor, CacheErrorInterceptor];

export * from "#interceptors/auth.interceptor";
export * from "#interceptors/cache.interceptor";
